export const terminalSelectDashboardKey = 'terminal-select:merchant-return-dashboard'
export const terminalSelectPalletConfigurationsKey = 'terminal-select:pallet-configurations'
